import { HTTP } from '../http'

export const SESSION_API = {
  postSession: async (url, data) => {
    return HTTP.post(
      url + 'session',
      data
    )
  },
  getSession: async (url, sessionId) => {
    return HTTP.get(
      url + 'session',
      { headers: { 'X-Session-ID': sessionId } }
    )
  },
  deleteSession: async (url, sessionId) => {
    return HTTP.delete(
      url + 'session',
      { headers: { 'X-Session-ID': sessionId } }
    )
  },
  getDomains: async (url) => {
    return HTTP.get(url + 'domains')
  },
  getPrivileges: async (url, data, sessionId) => {
    return HTTP.post(
      url + 'privileges',
      data,
      { headers: { 'X-Session-ID': sessionId } }
    )
  }
}
